import { render, staticRenderFns } from "./HorariosEntrega.vue?vue&type=template&id=1d8aaba3&scoped=true"
import script from "./HorariosEntrega.vue?vue&type=script&lang=js"
export * from "./HorariosEntrega.vue?vue&type=script&lang=js"
import style0 from "./HorariosEntrega.vue?vue&type=style&index=0&id=1d8aaba3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8aaba3",
  null
  
)

export default component.exports